import { gql } from '@apollo/client'

const DIET_CATEGORY_QUERY = gql`
  query dietCategory($id: ID!) {
    dietCategory(id: $id) {
      id
      name
      description
      descriptionUrl
      position
      maxPosition
      updatedAt
      updatedBy {
        id
        name
      }
      node {
        id
        name
        isCurationEnabled
        level
        idPath
        namePath
        type
      }
    }
  }
`

export default DIET_CATEGORY_QUERY
